import './bootstrap';
const _ = require('lodash');

import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();
